<template>
  <modal 
    :ignoreBackdropClick="true"
    :show.sync="shown"
    :show-close="false"
    headerClasses="justify-content-center"
    class="modal-options order-modal"
    modalClasses="modal-dialog-centered modal-dialog-scrollable"
  >
    <h3 slot="header" class="title-up font-weight-bold pt-3">We have a new app!</h3>

    <template>
      <div class="text-center">
      <el-image :src="business.logo" style="width:140ox; height:140px"></el-image>
      <p class="font-weight-bold">We have made some major improvements to our app.</p>
      <p class="font-weight-bold">Please click the link below to download it from the app store</p>
      <p class="font-weight-bold">We are looking forward to your next order!</p>
      </div>
    </template>
    <template slot="footer">
      <div class="text-center w-100">
      <a v-if="getStoreLinks" :href='getStoreLinks.playStore' class="btn w-75 bg-primary" target="_blank">
        <p class="title title-up mb-0 p-0" style="font-size:18px" v-html="'Click here <br>Download'"></p>
      </a>
      </div>
    </template>
  </modal>
</template>
<script>
import {
  Modal,
} from "@/components";
import { mapGetters } from 'vuex'
export default {
  name: "order-modal",
  components: {
    Modal,
  },
  props: {
    business: Object,
  },
  data() {
    return {
      shown: false,
      style: "style",
    };
  },
  computed: {
    ...mapGetters(["getStoreLinks"])
  },
  methods: {
    openModal() {
      this.shown = true;
    },
    closeModal() {
      this.shown = false;
    },

  },
};
</script>
<style scoped>
.form-group.input-group {
  padding: 0;
}
</style>
